import React, {Component, ReactElement} from 'react'
import {NatGetResidentUserAuthed} from '../residentUser/repository/NatGetResidentUserAuthed'
import NatResidentUserRepo, {UpdateResidentUserLoginedRequest} from '../residentUser/repository/NatResidentUserRepo'
import {MAIL_MAGAZINE_RECEIVING_DO_OR_NOT, NOTIFICATION_DO_OR_NOT} from '../../../CodeMaster'
import {Messages} from '../../../Messages'
import styled from 'styled-components'
import {WideMainContainer} from '../../../styledComponents/ContentsArea'
import {PlainLinkStyledBackButton, PrimaryStyledButton} from '../../../styledComponents/Button'
import NatDialogComponent from '../common/resident/NatDialogComponent'
import {Colors, FontSize} from '../../../styledComponents/Constants'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {NatAsyncCallFunction} from '../../common/util/Natutil'
import {Nullable} from '../../../app/TypeHelpers'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {Box} from '@mui/material'
import {
    BlockSpacer,
    currentMedia,
    GridItem,
    LabeledGridContainer,
} from '../../../styledComponents/ResponsiveConvenience'
import PPRadioGroupForResident from '../../../components/shared/forms/resident/PPRadioGroupForResident'
import {DisplayItemDividerForPageTop} from '../../../styledComponents/DisplayItem'
import {StyledPageTitle} from '../../../components/reservations/components/CommonStyle'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {ListGridContainer} from '../../../styledComponents/GridComponents'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {Location} from 'react-router-dom'

interface Props {
    residentUserRepo: NatResidentUserRepo,
    location: Location,
}

interface States {
    sutekiNetOfNotice: string
    bulletinBoardCommentNotice: string
    billingAmountFixNotice: string
    multiplePropertyOwnershipRecordCount: number
    version: number
    dialogChangeOpen: boolean
    dialogBackOpen: boolean
    isLoadCompleted: boolean
}

class NatResidentMailNoticeSettingPage extends Component<Props & ResidentPagePropsSet, States> {

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)

        this.state = {
            sutekiNetOfNotice: '',
            bulletinBoardCommentNotice: '',
            billingAmountFixNotice: '',
            multiplePropertyOwnershipRecordCount: 0,
            version: 0,
            dialogChangeOpen: false,
            dialogBackOpen: false,
            isLoadCompleted: false,
        }
        this.onChangeSutekiNetOfNotice = this.onChangeSutekiNetOfNotice.bind(this)
        this.onChangeBulletinBoardCommentNotice = this.onChangeBulletinBoardCommentNotice.bind(this)
        this.onChangeBillingAmountFixNotice = this.onChangeBillingAmountFixNotice.bind(this)
        this.handleChangeSettingButtonClick = this.handleChangeSettingButtonClick.bind(this)
        this.handleChangeCancelClick = this.handleChangeCancelClick.bind(this)
        this.handleChangeOkClick = this.handleChangeOkClick.bind(this)
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this)
        this.handleBackOkClick = this.handleBackOkClick.bind(this)
        this.handleBackCancelClick = this.handleBackCancelClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // ユーザ情報取得
            const retResidentUser: Nullable<NatGetResidentUserAuthed> = await NatAsyncCallFunction(
                this.props.residentUserRepo.getResidentUserLogined.bind(
                    this.props.residentUserRepo), this.props.navigate)

            if (retResidentUser && retResidentUser.details !== null) {
                this.setState({
                    sutekiNetOfNotice: retResidentUser.details.sutekiNetOfNotice,
                    bulletinBoardCommentNotice: retResidentUser.details.bulletinBoardCommentNotice,
                    billingAmountFixNotice: retResidentUser.details.billingAmountFixNotice,
                    multiplePropertyOwnershipRecordCount: retResidentUser.details.multiplePropertyOwnershipRecordCount,
                    version: retResidentUser.details.version,
                    dialogChangeOpen: false,
                    dialogBackOpen: false,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    onChangeSutekiNetOfNotice(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({sutekiNetOfNotice: event.target.value})
    }

    onChangeBulletinBoardCommentNotice(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({bulletinBoardCommentNotice: event.target.value})
    }

    onChangeBillingAmountFixNotice(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({billingAmountFixNotice: event.target.value})
    }

    handleChangeSettingButtonClick(): void {
        this.setState({dialogChangeOpen: true})
    }

    handleChangeCancelClick(): void {
        this.setState({dialogChangeOpen: false})
    }

    async handleChangeOkClick(): Promise<void> {
        this.setState({dialogChangeOpen: false})

        await this.props.eventEmitter.showLoading()
        try {
            const request: UpdateResidentUserLoginedRequest = {
                sutekiNetOfNotice: this.state.sutekiNetOfNotice,
                bulletinBoardCommentNotice: this.state.bulletinBoardCommentNotice,
                billingAmountFixNotice: this.state.billingAmountFixNotice,
                version: this.state.version,
            }
            // 居住者ユーザ更新
            const ret: Nullable<void> = await NatAsyncCallFunction(
                this.props.residentUserRepo.updateResidentUserLogined.bind(
                    this.props.residentUserRepo, request), this.props.navigate)

            if (ret) {
                this.props.navigate(
                    `/resident/personalSetting`,
                )
            }
        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                this.props.navigate(
                    `/resident/error`,
                    {
                        state: {
                            message: errorResponseBody.requestError.message,
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleBackButtonClick(): void {
        this.setState({dialogBackOpen: true})
    }

    handleBackOkClick(): void {
        this.props.navigate(`/resident/personalSetting`)
    }


    handleBackCancelClick(): void {
        this.setState({dialogBackOpen: false})
    }

    getChangeDialogComponent(): ReactElement | null {
        return (
            <NatDialogComponent
                open={this.state.dialogChangeOpen}
                params={{
                    title: '確認',
                    errorLevel: Messages.IOPCC0012.errorLevel,
                    message: Messages.IOPCC0012.toString('メール受信設定'),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.handleChangeCancelClick,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleChangeOkClick,
                        },
                    ],
                }}
            />
        )
    }

    getDialogBackComponent(): ReactElement | null {
        return (
            <NatDialogComponent
                open={this.state.dialogBackOpen}
                params={{
                    title: '確認',
                    errorLevel: Messages.WOPCC0001.errorLevel,
                    message: Messages.WOPCC0001.toString(''),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.handleBackCancelClick,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleBackOkClick,
                        },
                    ],
                }}
            />
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <PlainLinkStyledBackButton onClick={this.handleBackButtonClick}>
                    戻る
                </PlainLinkStyledBackButton>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <StyledPageTitle>
                    メール受信設定
                </StyledPageTitle>
                <Box height={'20px'}/>
                受信設定いただいた通知・メールマガジンをご登録中のメールアドレスにお送りします。
                {this.state.multiplePropertyOwnershipRecordCount > 1 &&
                    <>
                        <Box height={'10px'}/>
                        <ListGridContainer fontSize={FontSize.Middle}>
                            <div>・</div>
                            <div>複数のお部屋をお持ちの場合は、同じ設定がすべてのお部屋に適用されます。</div>
                        </ListGridContainer>
                    </>
                }
                <Box height={'20px'}/>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.VIEW_BILLING_AMOUNT}>
                    <ItemHeading>
                        ご請求金額の確定通知
                    </ItemHeading>
                    <WideMainContainer>
                        <Box height={'20px'}/>
                        <Box fontSize={FontSize.Middle}>
                            管理費等お知らせの機能で、ご請求金額が確定した場合に通知をお送りします。
                        </Box>
                        <Box height={'20px'}/>
                        <LabeledGridContainer>
                            <GridItem over={12}>
                                <PPRadioGroupForResident
                                    data={NOTIFICATION_DO_OR_NOT.values()}
                                    selectValue={this.state.billingAmountFixNotice}
                                    onChange={this.onChangeBillingAmountFixNotice}
                                />
                            </GridItem>
                        </LabeledGridContainer>
                        <Box height={'20px'}/>
                    </WideMainContainer>
                    <Box height={'15px'}/>
                </AuthorityChecker>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_BOARD_MANAGEMENT}>
                    <ItemHeading>
                        情報交換掲示板のコメント通知
                    </ItemHeading>
                    <WideMainContainer>
                        <Box height={'20px'}/>
                        <Box fontSize={FontSize.Middle}>
                            ご自身が作成したスレッドにコメントが投稿された場合に通知をお送りします。
                        </Box>
                        <Box height={'20px'}/>
                        <LabeledGridContainer>
                            <GridItem over={12}>
                                <PPRadioGroupForResident
                                    data={NOTIFICATION_DO_OR_NOT.values()}
                                    selectValue={this.state.bulletinBoardCommentNotice}
                                    onChange={this.onChangeBulletinBoardCommentNotice}
                                />
                            </GridItem>
                        </LabeledGridContainer>
                        <Box height={'20px'}/>
                    </WideMainContainer>
                    <Box height={'15px'}/>
                </AuthorityChecker>
                <ItemHeading>
                    すてきテラスのメールマガジン
                </ItemHeading>
                <WideMainContainer>
                    <Box height={'20px'}/>
                    <Box fontSize={FontSize.Middle}>
                        「すてきテラス」よりマンションに関するサービスのご紹介や暮らしに役立つ情報などを定期的にお届けいたします。
                    </Box>
                    <Box height={'20px'}/>
                    <LabeledGridContainer>
                        <GridItem over={12}>
                            <PPRadioGroupForResident
                                data={MAIL_MAGAZINE_RECEIVING_DO_OR_NOT.values()}
                                selectValue={this.state.sutekiNetOfNotice}
                                onChange={this.onChangeSutekiNetOfNotice}
                            />
                        </GridItem>
                    </LabeledGridContainer>
                    <Box height={'20px'}/>
                </WideMainContainer>
                <Box height={'30px'}/>
                <PrimaryStyledButton onClick={this.handleChangeSettingButtonClick}>
                    メール受信設定を変更する
                </PrimaryStyledButton>
                <Box height={'30px'}/>
                {this.getChangeDialogComponent()}
                {this.getDialogBackComponent()}
            </>
        )
    }
}

export default createResidentPage(NatResidentMailNoticeSettingPage)

const ItemHeading = styled.div`
  background-color: ${Colors.AccentLight};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 5px 15px;
  box-sizing: border-box;
  overflow: hidden;
`
